<template>
  <div>
    <!-- 弹窗 -->
    <el-dialog
        :before-close="handleCloses"
        :close-on-click-modal="false"
        :visible.sync="roleSettingsVisible"
        title="角色配置"
        top="15vh"
        width="50%"
    >
      <div class="tabs-box">
        <div class="tabs-content">
          <div class="tabs-info">
            <div class="tab-switch">
              <el-switch
                  v-model="enable"
                  active-color="#409EFF"
                  active-value="1"
                  inactive-color="#DCDFE6"
                  inactive-value="0"
              />
              <span>开启后模型角色才会持续生效</span>
            </div>
            <div class="identity-text">
              您可以通过文字描述，为不同的模型分配其对话角色，以使您轻松实现“圆桌对话”、“围炉吵架”等使用场景。比如，您为投资人，让不同的模型分别扮演管理人员、财务人员、销售人员、技术人员等角色，甚至可以加入对他们的性格、行为特点的描述，以训练该模型模拟真实场景与您展开多方会话。
            </div>
            <div class="identity-box">
              <div v-for="(item,index) in rows" :key="index" class="identity-item">
                <div class="identity-box-title">
                  <span>{{ item.model_name }}</span>

                </div>
                <el-input
                    v-model="item.role_content"
                    :autosize="{ minRows: 2 }"
                    placeholder="请输入内容"
                    style="width: 100%"
                    type="textarea"
                />
              </div>
            </div>
          </div>
        </div>
        <el-button class="save-btn" size="medium" type="primary" @click="confirm">确定</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>

import {robot_roles, save_robot_roles} from "@/api/chat";

export default {
  props: {
    roleSettingsVisible: {
      type: Boolean,
      default: true
    },
    robot_id: {
      type: Number,
      default: 0
    }

  },

  data() {
    return {
      rows: [],
      enable: false
    }
  },
  mounted() {
    this.robot_roles()
  },
  methods: {
    robot_roles() {
      robot_roles({robot_id: this.robot_id}).then(res => {
        this.enable = res.result.enable ? '1' : '0'
        this.rows = res.result.rows
      }).catch(() => {
      })
    },
    handleCloses() {
      this.$emit('update:roleSettingsVisible', false)
    },
    // 确定
    confirm() {
      save_robot_roles({
        robot_id: this.robot_id,
        enable: this.enable,
        roles: JSON.stringify(this.rows.map(el => {
          return {
            model_id: el.model_id,
            role_content: el.role_content
          }
        }))
      }).then(res => {
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
        this.$emit('update:roleSettingsVisible', false)
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 0;
}

.tabs-box {
  height: calc(100vh - 56px - 30vh);
  display: flex;
  align-items: flex-start;
  position: relative;

  .save-btn {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }

  .tabs-content {
    flex-grow: 1;
    overflow-y: auto;
    height: calc(100vh - 56px - 30vh - 52px);

    .tabs-info {
      margin: 20px 20px 10px 20px;

      .tab-switch {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          margin-left: 16px;
          font-weight: 500;
          font-size: 16px;
          color: #333333;
        }
      }

      .tabs-tone {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #858B9F;
      }

      .identity-text {
        color: #858B9F;
        line-height: 20px;
        text-align: left;
        margin-bottom: 20px;
      }

      .identity-box {
        .identity-item {
          padding: 12px;
          background: #F7F7F7;
          border-radius: 4px;
          margin-bottom: 10px;

          .identity-box-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 12px;
            color: #1A1A1A;
            line-height: 20px;
          }
        }
      }
    }

  }
}
</style>
